import { type FC, type SyntheticEvent } from 'react';

import { NarrowCardMoreControlsItem } from '@/microfrontends/listing/shared/containers/listing-cards/components/desktop/NarrowCardMoreControlsItem';
import { useHideOffer } from '@/microfrontends/listing/shared/containers/listing-cards/hooks/useHideOffer';

import { HideIcon } from '@/packages/shared-ui/components/HideIcon';

export const MoreItemHideOfferContainer: FC = () => {
  const hideOffer = useHideOffer();

  return (
    <NarrowCardMoreControlsItem
      icon={<HideIcon />}
      title="Скрыть"
      onClick={(e: SyntheticEvent) => {
        e.stopPropagation();
        hideOffer();
      }}
    />
  );
};
